module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4e76098e6208b7107977084461383563.png";